import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-inverse px-5 py-20 sm:py-24" data-id="element-86" data-mp="vf65316ilxma">
      <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="vh0q0fhsdpqd">
        <h2 className="font-display text-[1.85rem] font-black leading-tight tracking-tight text-surface sm:text-[2.6rem]" data-id="element-88" data-mp="19fgxw9rdxma3">
          Smetti di improvvisare.{' '}
          <span className="italic text-highlight" data-id="element-89" data-mp="15fq9udt8tk99">Inizia a insegnare.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-surface/70 sm:text-base" data-id="element-90" data-mp="1jb228ejxeyn0">
          Risolvi il tuo anno di Matematica in soli 5 minuti.
        </p>
        <div className="mt-8" data-id="element-91" data-mp="1t1n01zrrzz4v">
          <CtaButton label="Voglio Matematica Pronta ora" data-id="element-92" data-mp="1t514renwwkfh" />
        </div>
      </div>
    </section>;
}